import React, { useEffect, useState } from "react";
import {
  Table,
  TableRow,
  TableCell,
  TablePagination,
  TableSortLabel,
  makeStyles,
  TableHead,
  TableContainer,
} from "@material-ui/core";

import { withStyles } from "@material-ui/core/styles";

const StyledTableCell = withStyles(() => ({
  root: {
    padding: 5,
    whiteSpace: "nowrap",
  },
}))(TableCell);

export default function useTable(records, headCells, filterFn, noPagination) {
  const useStyles = makeStyles((theme) => ({
    table: {
      marginTop: theme.spacing(3),
      "& thead th": {
        fontWeight: "600",
        color: theme.palette.primary.main,
        backgroundColor: theme.palette.primary.light,
      },
      "& tbody td": {
        fontWeight: "300",
      },
      "& tbody tr:hover": {
        backgroundColor: "#fffbf2",
        cursor: "pointer",
      },
    },
    container: {
      maxHeight: !noPagination ? "50vh" : null,
    },
  }));

  const classes = useStyles();

  const [page, setPage] = useState(0);

  // pagination options
  const pages = noPagination ? [] : [5, 10, 25];

  // ✅ FIX: dynamic default
  const [rowsPerPage, setRowsPerPage] = useState(
    noPagination ? records.length || 1000 : 25
  );

  const [order, setOrder] = useState();
  const [orderBy, setOrderBy] = useState();

  const TblContainer = (props) => (
    <TableContainer className={classes.container}>
      <Table stickyHeader>{props.children}</Table>
    </TableContainer>
  );

  const TblHead = ({ styles }) => {
    const handleSortRequest = (cellId) => {
      const isAsc = orderBy === cellId && order === "asc";
      setOrder(isAsc ? "desc" : "asc");
      setOrderBy(cellId);
    };

    return (
      <TableHead>
        <TableRow>
          {headCells.map((headCell) => (
            <StyledTableCell
              key={headCell.id}
              sortDirection={orderBy === headCell.id ? order : false}
              style={{ fontWeight: "bolder", ...styles }}
            >
              {headCell.disableSorting ? (
                headCell.label
              ) : (
                <TableSortLabel
                  active={orderBy === headCell.id}
                  direction={orderBy === headCell.id ? order : "asc"}
                  onClick={() => handleSortRequest(headCell.id)}
                >
                  {headCell.label}
                </TableSortLabel>
              )}
            </StyledTableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // ✅ FIX: hide pagination if not used
  const TblPagination = () => {
    if (noPagination) return null;

    return (
      <TablePagination
        component="div"
        page={page}
        rowsPerPageOptions={pages}
        rowsPerPage={rowsPerPage}
        count={records.length}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    );
  };

  function stableSort(array, comparator) {
    const stabilized = array.map((el, index) => [el, index]);
    stabilized.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilized.map((el) => el[0]);
  }

  function getComparator(order, orderBy) {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  function descendingComparator(a, b, orderBy) {
    if (!orderBy) return 0;
    if (b[orderBy] < a[orderBy]) return -1;
    if (b[orderBy] > a[orderBy]) return 1;
    return 0;
  }

  // ✅ FIX: no slicing when noPagination
  const recordsAfterPagingAndSorting = () => {
    const sorted = stableSort(
      filterFn.fn(records),
      getComparator(order, orderBy)
    );

    if (noPagination) return sorted;

    return sorted.slice(
      page * rowsPerPage,
      (page + 1) * rowsPerPage
    );
  };

  // reset page when data changes
  useEffect(() => {
    setPage(0);
  }, [records.length]);

  return {
    TblContainer,
    TblHead,
    TblPagination,
    recordsAfterPagingAndSorting,
    styledTableCell: StyledTableCell,
  };
}